<img [src]="url || 'https://test.equipmyschool.com/assets/img/user-placeholder.png'">
